export enum RADashboardPortfolioType {
  Equity = "equity",
  FixedIncome = "fixed_income",
  MultiAsset = "multi_asset"
}

export type RADashboardAssetClassName = "Fixed Income" | "Equity" | "Multi-Asset"

export const AssetClassEnumLookup: Record<string, RADashboardPortfolioType> = Object.freeze({
  "Fixed Income": RADashboardPortfolioType.FixedIncome,
  "Equity": RADashboardPortfolioType.Equity,
  "Multi-Asset": RADashboardPortfolioType.MultiAsset
});

export const AssetClassNameLookup: Record<RADashboardPortfolioType, RADashboardAssetClassName> = Object.freeze({
  [RADashboardPortfolioType.FixedIncome]: "Fixed Income",
  [RADashboardPortfolioType.Equity]: "Equity",
  [RADashboardPortfolioType.MultiAsset]: "Multi-Asset",
})